import type { PartnerTypes } from "./PartnerTypes";
import type { Video } from "./Video";

export class Partner {
    id: string;
    sirioId: string;
    name: string;
    contactEmail: string;
    contactPhone: string;
    url: string;
    logoKey: string;
    logoUrl: string;
    color: string;
    type: PartnerTypes;
    mainFontFamily: string | undefined;
    actionFontFamily: string | undefined;
    dictionaryKey?: string;
    dictionaryUrl?: string;
    privacyPolicyKey?: string;
    privacyPolicyUrl?: string;
    footer?: string;
    bannerText?: string;
    loginTutorial?: Video;
    policyTutorial?: Video;
    claimTutorial?: Video;
    optionalFlags?: string[];
    mandatoryFlags?: string[];
    maintenance?: boolean;
    noPrivacyUrl?: boolean;
    hideVideos?: boolean;

    constructor(partner?: any) {
        this.id               = partner?.id ?? '';
        this.sirioId          = partner?.sirioId ?? '';
        this.name             = partner?.name ?? '';
        this.contactEmail     = partner?.contactEmail ?? '';
        this.contactPhone     = partner?.contactPhone ?? '';
        this.url              = partner?.url ?? '';
        this.logoKey          = partner?.logoKey ?? '';
        this.logoUrl          = partner?.logoUrl ?? '';
        this.color            = partner?.color ?? '';
        this.mainFontFamily   = partner?.mainFontFamily ?? null;
        this.actionFontFamily = partner?.actionFontFamily ?? null;
        this.type             = partner?.type ?? 'retail';
        this.dictionaryKey    = partner?.dictionaryKey;
        this.dictionaryUrl    = partner?.dictionaryUrl;
        this.privacyPolicyKey = partner?.privacyPolicyKey;
        this.privacyPolicyUrl = partner?.privacyPolicyUrl;
        this.footer           = partner?.footer;
        this.bannerText       = partner?.bannerText;
        this.loginTutorial    = partner?.loginTutorial;
        this.policyTutorial   = partner?.policyTutorial;
        this.claimTutorial    = partner?.claimTutorial;
        this.maintenance      = partner?.maintenance;
        this.noPrivacyUrl     = partner?.noPrivacyUrl;
        this.hideVideos       = partner?.hideVideos;
        this.optionalFlags    = partner?.optionalFlags ?? [];
        this.mandatoryFlags   = partner?.mandatoryFlags ?? [];
    }

    validate() {
        let errors: {[key: string]: boolean} = {};
        let valid: boolean = true;

        if (!this.color || this.color.trim().length === 0) {
            valid = false;
            errors['color'] = true;
        }

        if (!this.sirioId || this.sirioId.trim().length === 0) {
            valid = false;
            errors['sirioId'] = true;
        }

        if (!this.name || this.name.trim().length === 0) {
            valid = false;
            errors['name'] = true;
        }

        if (!this.contactEmail || this.contactEmail.trim().length === 0) {
            valid = false;
            errors['email'] = true;
        }

        if (!this.contactPhone || this.contactPhone.trim().length === 0) {
            valid = false;
            errors['phone'] = true;
        }

        if (!this.url || this.url.trim().length === 0) {
            valid = false;
            errors['url'] = true;
        }   

        return {
            errors: errors,
            isValid: valid
        }
    }
}